import React from 'react'
import ThemeMaker from '../../components/thememaker'
import { LabelList } from 'recharts';


import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar } from 'recharts';

// Sample data for the chart
const data = [
  { month: 'Jan', sentToSecondParty: 300, sentToFirstParty: 200 },
  { month: 'Feb', sentToSecondParty: 320, sentToFirstParty: 180 },
  { month: 'Mar', sentToSecondParty: 350, sentToFirstParty: 220 },
  { month: 'Apr', sentToSecondParty: 400, sentToFirstParty: 250 },
  { month: 'May', sentToSecondParty: 450, sentToFirstParty: 300 },
  { month: 'Jun', sentToSecondParty: 500, sentToFirstParty: 350 },
  { month: 'Jul', sentToSecondParty: 600, sentToFirstParty: 400 },
  { month: 'Aug', sentToSecondParty: 550, sentToFirstParty: 380 },
  { month: 'Sep', sentToSecondParty: 650, sentToFirstParty: 420 },
  { month: 'Oct', sentToSecondParty: 700, sentToFirstParty: 450 },
  { month: 'Nov', sentToSecondParty: 750, sentToFirstParty: 500 },
  { month: 'Dec', sentToSecondParty: 800, sentToFirstParty: 550 },
];
function Cugorsers() {
  return (
    <ThemeMaker>
       <div style={{ width: '100%', height: 400 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          {/* X Axis */}
          <XAxis dataKey="month" />
          {/* Y Axis */}
          <YAxis />
          {/* Grid */}
          <CartesianGrid strokeDasharray="3 3" />
          {/* Tooltip */}
          <Tooltip />
          {/* Legend */}
          <Legend />
          
          {/* Bar for data sent to second party */}
          <Bar dataKey="sentToSecondParty" fill="#8884d8">
            <LabelList dataKey="sentToSecondParty" position="top" />
          </Bar>

          {/* Bar for data sent to first party */}
          <Bar dataKey="sentToFirstParty" fill="#82ca9d">
            <LabelList dataKey="sentToFirstParty" position="top" />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>


    </ThemeMaker>

  )
}

export default Cugorsers